export default __webpack_public_path__ + "static/media/dongle_virus.bc0e397a.png";